// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__1w_h-","iframe":"Dashboard_iframe__CehSn"};